import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../../utils/constants'

class DealForm {
  constructor(data = {}) {
    const dealTypeInitial = { id: 0, name: '', deal_type_group: '' }
    const currencyInitial = { id: 0, name: '', code3: '', is_ndf: '' }
    this.deal_type = data.deal_type || dealTypeInitial
    this.client_side = ''
    this.currency_pair = ''
    this.quantity = ''
    this.client_price = ''
    this.market_maker_price = ''
    this.trade_date = dayjs().format(DATE_FORMAT.REGULAR_DATE_TIME)
    this.client_value_date = ''
    this.market_maker_value_date = ''
    this.client = ''
    this.market_maker = ''
    this.client_premium_amount = ''
    this.market_maker_premium_amount = ''
    this.client_premium_currency = currencyInitial
    this.market_maker_premium_currency = currencyInitial
    this.client_premium_date = ''
    this.market_maker_premium_date = ''
    this.settlement_date = ''
    this.expiry = ''
    this.put_call = ''
    this.cut = ''
    this.strike = ''
    this.fixing_date = ''
    this.fixing_source = ''
    this.client_trader_name = ''
    this.market_maker_trader_name = ''
    this.window_start = ''
    this.window_end = ''
    this.lower_barrier = ''
    this.upper_barrier = ''
    this.barrier = ''
    this.spot_ref = ''
    this.timing = ''
    this.payout_amount = ''
    this.payout_currency = currencyInitial
    this.client_far_price = ''
    this.market_maker_far_price = ''
    this.client_far_value_date = ''
    this.market_maker_far_value_date = ''
    this.client_note = ''
    this.market_maker_note = ''
    this.far_leg_quantity = ''
    this.far_fixing_date = ''
    this.trade_origin = 'FXER'
  }
}

export default DealForm
